import React from "react";
import BankingImg from "../../images/Banking.jpg";
import { Box, Container, Grid, Typography } from "@mui/material";

const BankingHero = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        // minHeight: { xs: 360, md: 620 },
        height: "100vh",
        backgroundImage: `url(${BankingImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Optional subtle dark overlay so text reads well on bright areas */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "rgba(0,0,0,0.15)",
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            bgcolor: "rgba(22, 45, 180, 0.82)",
            borderRadius: 0,
            px: { xs: 3, md: 6 },
            py: { xs: 4, md: 6 },
            width: "100%",
            maxWidth: 1180,
            mx: "auto",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
            {/* Left: Title */}
            <Grid item xs={12} md={5}>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                  fontSize: { xs: 35, sm: 45, md: 58 },
                  lineHeight: { xs: 1.02, md: 1.0 },
                }}
              >
                Our Banking
                <br />
                Solutions
              </Typography>
            </Grid>

            {/* Middle: Divider */}
            <Grid
              item
              xs={12}
              md={1}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "2px",
                  height: { xs: 0, md: 180 },
                  bgcolor: "rgba(255,255,255,0.65)",
                }}
              />
            </Grid>

            {/* Right: Description */}
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.95)",
                  fontSize: { xs: 14, md: 16 },
                  lineHeight: 1.7,
                  fontWeight: 600,
                }}
              >
                We support all major segments of the financial services
                industry. Our comprehensive position ensures we offer you sound
                perspective and practical solutions that optimize your value
                chain. AlphaForce's suite of services is designed to address the
                needs and challenges of your ever expanding client base.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const Banking = () => {
  return (
    <Box>
      <BankingHero />
      {/* Add the rest of the Banking page sections below */}
    </Box>
  );
};

export default Banking;
